

<div    [ngClass]="!isActive('/app/hotellist')?('main'):''"> 
  <!-- background-color: rgba(49, 100, 125, 0.727); background-color: rgba(49, 100, 125, 0.727); -->
<div class="col-md-12 row " [style]="!isActive('/app/hotellist')?(' padding-bottom: 50px;min-width: 1200px;'):' padding-bottom: 70px;min-width: 1300px;' " >
    <div class="col-md-12" *ngIf="!isActive('/app/hotellist')">

    <div class="outside-container  mainDiv" >
        <div class="box-container col-md-8"  style="min-width: 700px;">
                <div class="container" >
  <app-booking-menu-list></app-booking-menu-list>
  </div> 
 </div>
</div>
</div>


  
  <div class="col-md-12 " >
      <div class="outside-container " [style]="isActive('/app/hotellist')?('padding-top: 0; margin-top: -25px;'):''">
        <!-- <div *ngIf="!isActive('/app/hotellist')" class="sun"></div> -->

        <div class="box-container design" style="padding-bottom: 30px;">
                  <div class="container">
                      
                      <br>
                      <br>

                      <div class="row col-md-12 ">
                      
                          <div class="col-md-6">
                              <div  *ngIf="selectedDetail" class="card shadow col-md-3" [style]="!isActive('/app/hotellist')?('height:300px; position: absolute ; right:12%;top:36%; z-index: 2;min-width:350px ;'):'height:300px; position: absolute ; right:20%;top:12%; z-index: 2;min-width:350px ;'" >
                                          <div>
                                          <button type="button" class="close" data-dismiss="modal" (click)="closeDetail()">&times;</button>
                                          </div>


                                          <div class="room-selection">
                                            <!-- <h3>Select Rooms</h3> -->
                                            <!-- Room count dropdown -->
                                            
                                            <div class="col-md-12 row">
                                              <label class="col-md-6 pt-2" for="roomCount">Rooms:</label>
                                             <div class="col-md-5 styled-select">
                                              <select   [(ngModel)]="roomCount"  (change)="onRoomCountChange()">
                                                <option *ngFor="let count of roomOptions" [value]="count">{{ count }}</option>
                                              </select>
                                            </div>
                                            </div>
                                          
                                            <!-- Room details for each selected room -->
                                            <div *ngFor="let room of roomss; let i = index" class="room-details">
                                              <h6 class="d-flex justify-content-start">Room {{ i + 1 }}</h6>
                                              
                                              <!-- Number of adults -->
                                              <div class="col-md-12 row">
                                                <label class="col-md-6 pt-2" for="adults-{{i}}">Adults:</label>
                                                <div class="col-md-5 styled-select" >
                                                <select  [(ngModel)]="room.adults" id="adults-{{i}}" (change)="onAdultChange()">
                                                  <option *ngFor="let count of adultOptions"  [value]="count">{{ count }}</option>
                                                </select>
                                                </div>
                                                <!-- <input type="number" [(ngModel)]="room.adults" id="adults-{{i}}" min="1" /> -->
                                              </div>
                                          
                                              <!-- Number of children -->
                                              <div class="col-md-12 row pt-2 pb-2">
                                                <label class="col-md-6 " for="children-{{i}}">Children: <br>
                                                  <small style="color: gray; font-size: 10px;">0 - 11 Years Old</small>

                                                </label>
                                                
                                                <!-- <input type="number" [(ngModel)]="room.childrenCount" id="children-{{i}}" min="0" (input)="onChildrenCountChange(i)" /> -->
                                               <div class="col-md-5 styled-select" >
                                                <select [(ngModel)]="room.childrenCount" id="children-{{i}}" (change)="onChildrenCountChange(i)">
                                                  <option *ngFor="let count of childOptions" [value]="count">{{ count }}</option>
                                                </select>
                                              </div>
                                              </div>
                                          
                                              <!-- Children's ages -->
                                              <div class="col-md-12 row" *ngIf="room.childrenCount > 0" >
                                                <!-- <h5>Children's Ages</h5> -->
                                                <div class="col-md-6" *ngFor="let age of room.childrenAges; let j = index">
                                                  <label for="child-age-{{i}}-{{j}}">Child {{ j + 1 }} Age:</label>
                                                  <div class="styled-select">
                                                  <select [(ngModel)]="room.childrenAges[j]" id="child-age-{{i}}-{{j}}" >
                                                    <option *ngFor="let count of childAgeOptions" [value]="count">{{ count }}</option>
                                                  </select>
                                                </div>
                                                  <!-- <input type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="room.childrenAges[j]" id="child-age-{{i}}-{{j}}" min="0" max="11" /> -->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          

                                          <div *ngIf="false" class="row col-md-12 mt-2 d-flex justify-content-center">
                                            <div class="col-md-4 bold d-flex justify-content-start">Rooms </div>
                                            <div class="col-md-2" >
                                            <button (click)="iDecrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
                                            </div >{{ icurrentNumber }}
                                            <div class="col-md-2">  
                                            <button (click)="iIncrement()" class="circle-button">
                                            <span class="plus-icon pb-1">+</span>
                                            </button>
                                            </div>
                                        </div>
                                        <span *ngIf="false" >
                                          <div class="row col-md-12 mt-2 d-flex justify-content-center">
                                              <div class="col-md-4 bold d-flex justify-content-start" click >Adults </div>
                                              <div class="col-md-2 " >
                                              <button (click)="decrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
                                              </div >{{ currentNumber }}
                                              <div class="col-md-2">
                                              <button (click)="increment()" class="circle-button">
                                              <span class="plus-icon pb-1">+</span>
                                              </button>
                                              </div> 
                                          </div>
                                          <div class="row col-md-12 mt-2 d-flex justify-content-center">
                                              <div class="col-md-4 bold " style="text-align: left;">Children <br>
                                                <small style="color: gray; font-size: 10px;">0 - 11 Years Old</small>
                                              </div>
                                              <div class="col-md-2" >
                                                  <button (click)="cDecrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
                                              </div >{{ ccurrentNumber }}
                                              <div class="col-md-2">
                                              <button (click)="cIncrement()" class="circle-button">
                                                  <span class="plus-icon pb-1">+</span>
                                              </button>
                                              </div>
                                          </div>
                                        
                                          
                                         
                                          <br>
                                          <form [formGroup]="searchFg" class="pb-3" style="background-color: white;padding-left: 4px;">
                                            <div formArrayName="childrenAges" class="col-md-12 row"> 
                                              <div class="col-md-6 mt-2" *ngFor="let age of childrenAges.controls; let i = index">
                                                <input  type="text" (keypress)="onlyNumberKey($event)" class="form-control" [formControlName]="i" min="0" max="11" placeholder="Child age (0-11 years)">
                                              </div>
                                            </div>
                                          </form>
                                          
                                          <br>
                                        </span>
                                          
                              </div>
                      </div>
                      </div>
                      <!-- <div *ngIf="showOneWay&&!pending || showReturn&&!pending" [class]="!isActive('/app/hotellist')?('mt-2  col-md-12 d-flex justify-content-center'):'mt-2 row col-md-12'" style="padding-left:12px ;">

                        <div class="col-md-10 border " style="border-radius: 4px; padding: 4px;background-color: white;">
                         
                      <form  [formGroup]="searchFg" class=" d-flex justify-content-start" >
                        <mat-radio-group color="primary" [(ngModel)]="type" (change)="onDOMINTChange($event)" [ngModelOptions]="{standalone: true}"  aria-label="Select an option"   >
                            <mat-radio-button  value="D">Domestic</mat-radio-button>
                            <mat-radio-button *ngIf="!pendingINT" value="I">International</mat-radio-button>
                            <img *ngIf="pendingINT" src="../../../assets/images/time.gif" style="height:40px;border-radius: 4px; margin-left: 2rem;" alt="">

                          </mat-radio-group>
                          
                         
                    </form></div></div> -->
                      <div *ngIf="showOneWay&&!pending || showReturn&&!pending" [class]="!isActive('/app/hotellist')?('mt-2  col-md-12 d-flex justify-content-center'):'mt-2 row col-md-12'" style="padding-left:12px ;">

                          <div class="col-md-10 border " style="border-radius: 4px; padding: 4px;background-color: white;">
                           
                            
                            <form [formGroup]="searchFg"  class="row">  

                        
                                      <div class="col-md-4 "   style="border-right:1px solid #DEE2E6 ;text-align: left;" >
                                  
                                          <mat-label #CheckIn class="col-md-12 bold" style="color:#007bff ;">City, Property Name Or Location <span style="color: red;">*</span></mat-label>
                                          <div     class="bold col-md-12" [style]="!isActive('/app/hotellist')?('font-size: 30px;height:30px'):'display:none'" >
                                             <!-- {{departure}} -->

                                          </div>
                                          <app-drop-down style="flex: 1;" name="filterBranch" [modelInput]="addresstextValue" [ngModelOptions]="{standalone: true}"
                                          [params]="branchFilterParams"  (onSelectItem) = "invokeEventss($event)" (onInput)="onInput($event)" [list]="suggestions"> 
                                      </app-drop-down>  
                                          
                                          <!-- <input type="text" style="outline: none; border: none; border-bottom: 1px solid #757575;border-radius: 0;width: 100%;" [(ngModel)]="addresstextValue"  [ngModelOptions]="{standalone: true}" (input)="onInput()" placeholder="Enter a city" />
                                          <div *ngIf="suggestions.length > 0" class="suggestions">
                                            <div *ngFor="let place of suggestions" (click)="invokeEvent(place)">
                                              {{ place.formatted_address }}
                                            </div>
                                           
                                          </div> -->
                                          <!-- <div class="input-group" style="width: 95%; margin: 5px;">
                                            <span class="input-group-addon">
                                              <i class="fa fa-map-marker"></i>
                                            </span>
                                            <input

                                              #addresstextInput
                                              type="text"
                                              placeholder="Enter location"
                                              [ngModelOptions]="{standalone: true}"
                                              [(ngModel)]="addresstextValue"
                                              
                                              style="outline: none; border: none; border-bottom: 1px solid #757575;border-radius: 0;width: 100%;"
                                            />
                                          </div> -->
                                          
      
                                          <!-- <mat-chip-grid #chipGrid aria-label="Fruit selection">
                                          </mat-chip-grid>
                                          <input class="mainbox col-md-12"  #CheckIn  [formControl]="fruitCtrl"  
                                              [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                              (matChipInputTokenEnd)="add($event)"/>
                                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                          <mat-option class="mat-primary" *ngFor="let city of filteredFruits | async" [value]="city">
                                          {{city}}
                                          </mat-option>
                                          </mat-autocomplete>
                                          <small *ngIf="fromAirportError" class="warn">Please select flight details!</small>
                           -->
                                      </div>
                  
                                      
                              
                                      <div class="col-md-2" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer" (click)="pickers.open()">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Check-In</mat-label>
                                              <input class="mainbox"  style="color: transparent;padding: 0;margin: 0; font-size: 1px;" formControlName="requestedDate" readonly [min]="minData" [matDatepicker]="pickers"   (dateChange)="onOneWayDate()">
                                            <div class="col-md-12" *ngIf="!isActive('/app/hotellist')">
                                              <span class=" bold" [style]="!isActive('/app/hotellist')?('font-size: 35px;'):'font-size: 20px;'">{{departureTime[0]}}</span>&nbsp;&nbsp;<span  [style]="!isActive('/app/hotellist')?('font-size: 23px;'):'font-size: 18px;'">{{departureTime[1]}}</span><span  [style]="!isActive('/app/hotellist')?('font-size: 25px;'):'font-size: 20px;'">{{departureTime[2]?("'"+departureTime[2]):''}}</span>
                                              <br><span class=" bold" style="font-size: 15px; ">{{departureTime[3]}}</span>
                                            </div>
                                            <div *ngIf=" isActive('/app/hotellist')">
                                                <span class="bold"> {{departureTime}}</span> 
                                               </div>
                                              <mat-datepicker #pickers ></mat-datepicker>
                                      </div>
                                  
                                      <div class="col-md-2" (click)="picker.open()" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Check-Out</mat-label>

                                          <input   style="color: transparent;padding: 0;margin: 0; font-size: 1px;" class="mainbox" readonly [min]="date1Plus(searchFg.value.requestedDate)" [matDatepicker]="picker" formControlName="returnDate" (dateChange)="onRChangeDate()">
                                          <div *ngIf="arrivelTime && !isActive('/app/hotellist')" class="col-md-12">
                                            <span  class=" bold" [style]="!isActive('/app/hotellist')?('font-size: 35px;'):'font-size: 20px;'">{{arrivelTime[0]}}</span>&nbsp;&nbsp;<span  [style]="!isActive('/app/hotellist')?('font-size: 23px;'):'font-size: 18px;'">{{arrivelTime[1]}}</span><span  [style]="!isActive('/app/hotellist')?('font-size: 25px;'):'font-size: 20px;'">{{arrivelTime[2]?("'"+arrivelTime[2]):''}}</span>
                                            <br><span class=" bold" style="font-size: 15px; ">{{arrivelTime[3]}}</span>
                                          </div>
                                          <div *ngIf="arrivelTime && isActive('/app/hotellist')">
                                           <span class="bold"> {{arrivelTime}}</span> 
                                          </div>
                                          <div class="bold" *ngIf="!arrivelTime" style="font-size: 12px;">Tap&nbsp;to&nbsp;add&nbsp;a&nbsp;Check-Out&nbsp;date</div>
                                          <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
                                          <mat-datepicker #picker></mat-datepicker>
                                          
                                      </div>
                                      <div class="col-md-2" style="text-align: left;cursor: pointer;" (click)="SelectDetail()">
                                        <mat-label class="col-md-12 bold" style="color:#007bff ;">Rooms & Guests</mat-label>
                                        <span class="d-flex justify-content-start pointer" style="position:relative" > <mat-icon >person</mat-icon>{{rooms}}&nbsp;{{adult}}&nbsp;{{child}}</span>

                                      </div>

                                        <div class="col-md-2" *ngIf="!isActive('/app/hotellist')&&showOneWay ||!isActive('/app/hotellist')&& showReturn">
                                          <button style="width: 100%;height:20px; border-radius: 30px; " mat-raised-button color="accent"  (click)="searchHotel()">
                                          <!-- <mat-icon >search</mat-icon>  -->
                                          <span class="bold" style="font-size:xx-large;" >SEARCH</span>
                                          </button>  
                                      </div>
                                     
                                  </form>     
                                     
                              </div>

                              <div class="col-md-2" *ngIf="isActive('/app/hotellist')">
                                <button style="width: 100%; border-radius: 10px; " mat-raised-button color="accent" (click)="searchHotel()" >
                                <!-- <mat-icon >search</mat-icon>  -->
                                <span class="bold" style="font-size: xx-large;" >SEARCH</span>
                                </button>  
                              </div>  
                      </div>
                      <!-- <div *ngIf="!pending" class="d-flex justify-content-start" [style]="isActive('/app/hotellist')?(''):'padding-left: 8rem'">
                      <mat-checkbox  class="checkbox-btn" color="primary" [(ngModel)]="packageRate">Package Rate</mat-checkbox>
                    </div> -->
                    <div *ngIf="pending" class="d-flex justify-content-start" [style]="isActive('/app/hotellist')?(''):'padding-left: 15rem'">
                  <img src="../../../assets/images/time.gif" style="height:200px;border-radius: 4px;" alt="">
                    </div>
                  
                     


                      <div *ngIf="showMulti" class="row">

                      <div *ngFor="let item of array" class="col-md-8">
                        <div class="col-md-12 row">
                            <form   class="row">  
                                <mat-form-field class="col-md-4 " appearance="outline" >
                                    <mat-icon matSuffix>flight_takeoff</mat-icon>
                            
                                    <mat-label>Where from?</mat-label>
                                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                                    </mat-chip-grid>
                                    <input  #fruitInput  [formControl]="fruitCtrl" [(ngModel)]="item.fromAirport"
                                        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        (matChipInputTokenEnd)="add($event)"/>
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                    <mat-option *ngFor="let airports of filteredFruits | async" [value]="airports">
                                    {{airports}}
                                    </mat-option>
                                    </mat-autocomplete>
                                    <small *ngIf="fromAirportError" class="warn">Please select flight details!</small>
                    
                                </mat-form-field>
            
                                <mat-form-field class="col-md-4" appearance="outline">
                                    <mat-icon matSuffix>flight_land</mat-icon>
                        
                                    <mat-label>Where To?</mat-label>
                                    <mat-chip-grid #chipGrids aria-label="city Selection">
                                    </mat-chip-grid>
                                    <input  #airportToInput [formControl]="ToCtrl" [(ngModel)]="item.toAirport"
                                        [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                                        (matChipInputTokenEnd)="addTo($event)"/>
                                        <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                                        <mat-option *ngFor="let airport of filteredTo | async" [value]="airport">
                                        {{airport}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <small *ngIf="toAirportError" class="warn">Please select flight details!</small>
                                </mat-form-field>
                        
                                <mat-form-field class="col-md-4" appearance="outline">
                                        <input matInput [min]="minData" [(ngModel)]="item.requestedDate" [matDatepicker]="pickers" formControlName="requestedDate" (dateChange)="onOneWayDate()">
                                        <mat-label>Date</mat-label>
                                        <mat-datepicker-toggle matIconSuffix [for]="pickers" ></mat-datepicker-toggle>
                                        <mat-datepicker #pickers></mat-datepicker>
                                </mat-form-field>
                            
                               
                                
                            </form>           
                        </div>                      </div>




                       <div class=" col-md-4 row" style="padding: 0;">
                        <div class="col-md-6 ">  
                            <button style="width: 100%;" mat-raised-button  color="accent"  >
                            <mat-icon >search</mat-icon> 
                            <span >SEARCH FLIGHT</span>
                            </button>    
                        </div>
                        <div class="col-md-6 row">  
                  <div *ngIf="!AddCity" class="col-md-8" style="margin-right: -20px;">
                      <button   mat-raised-button style="height: 50px;"  (click)="clickMulticity()"> <img src="assets/images/Add_24.png"> City</button>

                    </div>
                        <div  *ngIf="clearCity" class="col-md-4" >

                      <button  type="button"   class="close" (click)="clear()">&times;</button></div>
                    </div>
                </div>
                      </div>
                </div> 

              </div> 
              <!-- <div  *ngIf="!isActive('/app/hotellist')&&showOneWay ||!isActive('/app/hotellist')&& showReturn" class="col-md-12 d-flex justify-content-center" [style]="!isActive('/app/hotellist')?(' margin-top:-20px'):'position: absolute; top:13%'" >  
                <div class="col-md-2" >
                  <button style="width: 100%;height:20px; border-radius: 30px; " mat-raised-button color="accent"  (click)="searchHotel()">
                  <span class="bold" style="font-size:xx-large;" >SEARCH</span>
                  </button>  
                </div>  
              </div> -->
      </div>
  </div>
</div>

<span *ngIf="isActive('/app/hotel')">

  <div class="cont" style="display: flex; justify-content: center;" *ngIf="currentItem">
   
  <div *ngIf="htmlContent" class="tab-content">
    <div style="margin-top: 20px;">
        <div [innerHTML]="htmlContent" style="border: 1px solid #ff9933;border-radius: 4px; padding: 10px;text-align: start;background-color: transparent;font-family:Courier New"></div>
      </div>
</div>  
</div></span>
<!-- <app-offers *ngIf="!isActive('/app/hotellist')"></app-offers> -->
